document.addEventListener('DOMContentLoaded', function () {
  if (window.jQuery && jQuery.fn.fancybox) {
    jQuery('[data-fancybox="customisation-gallery"]').fancybox({ loop: true });
  }

  document.querySelectorAll('.customisation-gallery').forEach(function (gallery) {
    var grid = gallery.querySelector('[data-customisation-gallery-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-customisation-gallery-card]'));
    var filterButtons = Array.prototype.slice.call(gallery.querySelectorAll('.customisation-gallery__filter'));
    var activeLabelEl = gallery.querySelector('[data-customisation-gallery-active-filter]');
    var filtersEl = gallery.querySelector('[data-customisation-gallery-filters]');
    var filtersToggle = gallery.querySelector('[data-customisation-gallery-filters-toggle]');
    var loadMoreBtn = gallery.querySelector('[data-customisation-gallery-load-more]');
    var showMoreBtn = gallery.querySelector('[data-customisation-gallery-show-more]');
    var perPage = parseInt(grid.getAttribute('data-per-page'), 10) || 9;

    var currentFilter = 'all';
    var revealCount = perPage;

    function refresh() {
      var shown = 0;
      var matchingTotal = 0;

      cards.forEach(function (card) {
        var cats = (card.getAttribute('data-categories') || '').split(',').filter(Boolean);
        var matches = currentFilter === 'all' || cats.indexOf(currentFilter) !== -1;

        if (!matches) {
          card.classList.add('is-filtered-out');
          return;
        }

        card.classList.remove('is-filtered-out');
        matchingTotal++;

        if (shown < revealCount) {
          card.classList.remove('is-hidden');
          shown++;
        } else {
          card.classList.add('is-hidden');
        }
      });

      if (loadMoreBtn) {
        loadMoreBtn.style.display = shown < matchingTotal ? '' : 'none';
      }
    }

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        currentFilter = btn.getAttribute('data-filter');
        revealCount = perPage;
        filterButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (activeLabelEl) activeLabelEl.textContent = btn.textContent.trim();
        if (filtersEl) filtersEl.classList.remove('is-open');
        if (filtersToggle) filtersToggle.setAttribute('aria-expanded', 'false');
        refresh();
      });
    });

    if (filtersToggle && filtersEl) {
      filtersToggle.addEventListener('click', function () {
        var isOpen = filtersEl.classList.toggle('is-open');
        filtersToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        revealCount += perPage;
        refresh();
      });
    }

    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', function () {
        gallery.querySelectorAll('.customisation-gallery__filter--extra').forEach(function (b) {
          b.classList.remove('is-hidden');
        });
        showMoreBtn.style.display = 'none';
      });
    }

    refresh();
  });
});
